export { default as Form } from 'catalogs/components/form/CatalogForm';



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/form/index.js